<template>
	<v-card>
		<v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
			<v-card color="primary" dark>
				<v-card-text class="pt-3">
					Aguarde enquanto o boleto é gerado!
					<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogErro.status" persistent>
			<CardDialog :dialog="dialogErro" />
		</v-dialog>
		<v-card-title class="title">
			<v-row no-gutters>
				<v-col class="d-none d-md-block pr-1">
					<InputDatePicker
						:disabled="carregando"
						v-model="busca.dtinicio"
						label="Data inicial"
						:outlined="true"
						:dense="true"
					/>
				</v-col>
				<v-col class="d-none d-md-block px-1">
					<InputDatePicker
						:disabled="carregando"
						v-model="busca.dtfim"
						label="Data final"
						:outlined="true"
						:dense="true"
					/>
				</v-col>
				<v-col class="d-none d-md-block px-1" v-if="permissao('parcelamento_boleto_filtro_empresa')">
					<v-autocomplete
						:items="filiaisFiltro"
						clearable
						item-text="filial"
						item-value="idfilial"
						label="Filial"
						outlined
						dense
						:disabled="carregando"
						v-model="busca.idfilial"
					></v-autocomplete>
				</v-col>
				<v-col class="d-none d-md-block px-1">
					<v-text-field label="Título" outlined dense :disabled="carregando" v-model="busca.titulo"></v-text-field>
				</v-col>
				<v-bottom-sheet class="d-flex d-md-none" v-model="sheet">
					<v-sheet class="text-center" height="100%">
						<v-row class="pa-3">
							<v-col cols="6" class="mb-n3 px-2">
								<InputDatePicker
									:disabled="carregando"
									v-model="busca.dtinicio"
									label="Data inicial"
									:outlined="true"
									:dense="true"
								/>
							</v-col>
							<v-col cols="6" class="mb-n3 px-2">
								<InputDatePicker
									:disabled="carregando"
									v-model="busca.dtfim"
									label="Data final"
									:outlined="true"
									:dense="true"
								/>
							</v-col>
							<v-col cols="6" class="mb-n8 px-2" v-if="usuario.idgrupo == 1">
								<v-autocomplete
									:items="filiaisFiltro"
									clearable
									item-text="filial"
									item-value="idfilial"
									label="Filial"
									outlined
									dense
									:disabled="carregando"
									v-model="busca.idfilial"
								></v-autocomplete>
							</v-col>
							<v-col :cols="usuario.idgrupo == 1 ? 6 : 12" class="mb-n8 px-2">
								<v-text-field label="Título" outlined dense :disabled="carregando" v-model="busca.titulo"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-btn text class="mt-n3" color="primary" @click="sheet = !sheet">Cancelar</v-btn>
							</v-col>
							<v-col cols="6">
								<v-btn text class="mt-n3" color="primary" @click="listar(0), sheet = !sheet">Filtrar</v-btn>
							</v-col>
						</v-row>
					</v-sheet>
				</v-bottom-sheet>
				<v-col class="pl-1">
					<v-autocomplete
						no-filter
						v-model="busca.idcliente"
						outlined
						dense
						label="Cliente"
						:search-input.sync="searchMobile"
						:items="items"
						:loading="carregando"
						item-text="nome"
						item-value="idcliente"
						class="d-flex d-md-none"
						@change="listar(0)"
						append-outer-icon="mdi-menu"
						@click:append-outer="sheet = !sheet"
					></v-autocomplete>
					<v-autocomplete
						no-filter
						v-model="busca.idcliente"
						outlined
						dense
						label="Cliente"
						:search-input.sync="search"
						:items="items"
						:loading="carregando"
						item-text="nome"
						item-value="idcliente"
						class="d-none d-md-block"
						@change="listar(0)"
					></v-autocomplete>
				</v-col>
				<v-col cols="auto" class="ml-2">
					<v-btn
						:disabled="carregando"
						class="mt-1"
						color="primary"
						elevation="0"
						fab
						x-small
						@click="listar(0)"
					>
						<v-icon>mdi-magnify</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-title>
		<v-divider />
		<v-progress-linear indeterminate absolute :active="carregando" />
		<v-card-text>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">Filial</th>
							<th class="text-left">Cliente</th>
							<th class="text-left">Titulo</th>
							<th class="text-left">Digito</th>
							<th class="text-left">Data de movimento</th>
							<th class="text-left">Data de vencimento</th>
							<th class="text-left">Valor do título</th>
							<th class="text-left">Valor de juros</th>
							<th class="text-left">Valor total</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<template v-if="dados.total > 0">
							<tr v-for="(u, i) in dados.lista" :key="i">
								<td class="text-truncate">{{u.idfilial}} - {{u.filial}}</td>
								<td>{{u.idcliente}} - {{u.cliente}}</td>
								<td>{{u.titulo}}</td>
								<td>{{u.digito}}</td>
								<td>{{u.dtmovimento}}</td>
								<td>{{u.dtvencimento}}</td>
								<td>{{u.saldotitulo | formataDinheiro}}</td>
								<td>{{u.jurostitulo | formataDinheiro}}</td>
								<td>{{u.valorliqtitulo | formataDinheiro}}</td>
								<td class="text-truncate text-center" v-if="u.flagexportado == 'F'">
									<v-btn
                      v-if="false"
										:disabled="carregando"
										class="px-2"
										elevation="0"
										color="primary"
										small
										@click="emitirBoleto(u)"
									>
										<v-icon class="pr-1">mdi-barcode</v-icon>Gerar boleto
									</v-btn>
                  <v-chip small class="white--text" color="red" label>
                    <v-icon small class="pr-1">mdi-information</v-icon>Novos boletos devem ser emitidos com Pix.
                  </v-chip>
								</td>
								<td v-else class="text-truncate text-center">
									<v-btn
										:disabled="carregando"
										class="px-2"
										elevation="0"
										color="primary"
										small
										@click="reimprimirBoleto(u)"
									>
										<v-icon class="pr-1">mdi-barcode</v-icon>Reimprimir boleto
									</v-btn>
								</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="10">Nenhum registro encontrado.</td>
							</tr>
						</template>
					</tbody>
				</template>
			</v-simple-table>
			<Paginacao
				:total="dados.total"
				@atualizar="listar"
				:carregando="carregando"
				:pg="pgSelecionada"
			/>
		</v-card-text>
		<v-progress-linear indeterminate absolute :active="carregando" />
	</v-card>
</template>


<script>
import axios from "axios";
import { mapState } from "vuex";
import mixinFilial from "../../util/mixinFilial";
import CardDialog from "../Widgets/CardDialog";
import Paginacao from "../Widgets/Paginacao";
import InputDatePicker from "../Widgets/InputDatePicker.vue";
//import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";

export default {
	name: "ParcelamentoBoleto",
	components: { CardDialog, InputDatePicker, Paginacao },
	mixins: [mixinFilial],
	data: () => ({
		sheet: false,
		carregando: false,
		dialogLoading: false,
		dialogErro: {
			status: false,
			title: "",
			msg: "",
			icon: "",
			iconColor: "",
		},
		dados: { total: 0 },
		busca: {
			dtinicio: `${new Date().getFullYear()}-${
				(new Date(
					new Date().getFullYear(),
					new Date().getMonth() + 1,
					0
				).getMonth() +
					1 <
				10
					? "0"
					: "") +
				(new Date().getMonth() + 1)
			}-01`,
			dtfim: `${new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getFullYear()}-${
				(new Date(
					new Date().getFullYear(),
					new Date().getMonth() + 1,
					0
				).getMonth() +
					1 <
				10
					? "0"
					: "") +
				(new Date().getMonth() + 1)
			}-${new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getDate()}`,
			idcliente: null,
			titulo: null,
		},
		aguardarBusca: "",
		nomeLimit: 50,
		clientes: [],
		search: null,
		searchMobile: null,
		pgSelecionada: 0,
	}),
	computed: {
		...mapState(["backendUrl", "pgLimit", "timeLimit", "usuario"]),
		items() {
			if (this.clientes == null) return;

			this.clientes.forEach((cliente) => {
				if (cliente.nome.length > this.nomeLimit) {
					cliente.nome =
						cliente.nome.slice(0, this.nomeLimit) + "...";
				}
			});

			return this.clientes;
		},
		filiaisFiltro() {
			if (this.filiais.lista) {
				return this.filiais.lista.filter((v) => {
					return (
						v.idfilial != 6 &&
						v.idfilial != 12 &&
						v.idfilial != 25 &&
						v.idfilial != 29 &&
						v.idfilial != 33 &&
						v.idfilial != 37
					);
				});
			} else {
				return [];
			}
		},
	},
	methods: {
		carregarClientes(val) {
			clearTimeout(this.aguardarBusca);
			this.aguardarBusca = setTimeout(() => {
				this.carregando = true;
				return axios
					.post(`${this.backendUrl}cliente/listar`, {
						limit: 30,
						offset: 0,
						busca: val || null,
					})
					.then((res) => {
						this.clientes = res.data.lista;
						this.carregando = false;
					})
					.catch(() => {
						this.carregando = false;
					});
			}, this.timeLimit);
		},
		listar(pg) {
			this.pgSelecionada = pg;
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}parcelamento/boleto/listar`, {
					limit: this.pgLimit,
					offset: this.pgLimit * pg,
					dtini: this.busca.dtinicio || null,
					dtfim: this.busca.dtfim || null,
					idfilial: this.busca.idfilial || null,
					idcliente: this.busca.idcliente || null,
					titulo: parseInt(this.busca.titulo) || null,
				})
				.then((res) => {
					this.dados = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		emitirBoleto(titulo) {
			this.carregando = true;
			this.dialogLoading = true;
			return axios
				.post(`${this.backendUrl}parcelamento/boleto/emitir`, {
					...titulo,
				})
				.then((res) => {
					this.carregando = false;
					this.dialogLoading = false;
					if (res.data) {
						let htmlContent;
						let data = new Date();
						let nome = `boleto_${
							data.toISOString().split(".")[0]
						}.pdf`;
						htmlContent = `<!DOCTYPE html>
                    <html>
                        <head>
                            <title>Boleto Online</title>
                            <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
                        </head>

                        <body style="padding:15pt !important;">
                            <table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;margin-top:20px;font-family:Arial !important;">
                                <tr>
                                    <td>
                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td colspan="2" rowspan="2" valign="bottom" style="color:white; height:28px;">
                                                </td>
                                                <td width="45%" valign="bottom">
                                                    <div align="right">
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img src="data:image/gif;base64,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" />
                                                    <img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
                                                </td>
                                                <td valign="bottom" style="font-size:12.5px;font-weight:bold;">
                                                    <div align="right">
                                                        <img width="80px" src="data:image/jpeg;base64,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" />
                                                        <br />
                                                        <span>Recibo do Pagador</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Local de Pagamento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:10.5px">
                                                                ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
                                                                NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS 
                                                                E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Vencimento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
                                                                ${
																	titulo.dtvencimento
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">
                                                                ${
																	res.data
																		.cedente
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%" valign="bottom">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.agencia
																		}/${
							res.data.conta
						}-${res.data.digito}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${new Date(
																			new Date()
																		).toLocaleDateString(
																			"pt-BR"
																		)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">DM</div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.aceite
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}/${
							res.data.calculanossonumero
						}-${res.data.calculadac2}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center"></div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center" style="font-size:11.5px;">R$</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="top">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                                        ${parseFloat(
																			titulo.valorliqtitulo
																		).toLocaleString(
																			"pt-br",
																			{
																				style: "currency",
																				currency:
																					"BRL",
																			}
																		)}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height="90" colspan="3" rowspan="3" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;font-weight:bold;">
                                                                <span>
                                                                    ${
																		res.data
																			.instrucoes[0]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[1]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[2]
																	}</br>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (-) Desconto/Abatimento</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (+) Mora/Multa</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (=) Valor Cobrado</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="434" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.cliente
																	}<br>
                                                                    ${
																		res.data
																			.endereco
																	}
                                                                    ${
																		res.data
																			.cep
																	}
                                                                    ${
																		res.data
																			.cidade
																	}-${
							res.data.uf
						}
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    CNPJ/CPF ${
																		res.data
																			.cpfcnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="428">
                                                                <span style="font-size:11.5px">
                                                                    ${
																		res.data
																			.empresa
																	} <br>
                                                                    ${
																		res.data
																			.empresaendereco
																	} - ${
							res.data.empresacep
						} - ${res.data.empresacidade} <br>
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.empresacnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div align="right" style="font-size:11.5px;font-weight:bold;">
                                            Autenticação Mecânica
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td height="5">
                                        ...................................................................................................................................................
                                    </td>
                                </tr>
                            </table>
                            <table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;font-family:Arial !important;">
                                <tr>
                                    <td colspan="2">
                                        <table width="100%"  border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td colspan="2" rowspan="2" valign="bottom" style="color:white;height:28px;">
                                                </td>
                                                <td width="72%" valign="bottom"><div align="right"></div></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img src="data:image/gif;base64,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" />
                                                    <img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
                                                </td>
                                                <td valign="bottom" style="white-space: nowrap;">
                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                        <p style="white-space: nowrap;">
                                                            ${
																res.data
																	.numeroboleto
															}
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Local de Pagamento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:10.5px">
                                                                ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
                                                                NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS 
                                                                E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Vencimento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
                                                                ${
																	titulo.dtvencimento
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">
                                                                ${
																	res.data
																		.cedente
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%" valign="bottom">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.agencia
																		}/${
							res.data.conta
						}-${res.data.digito}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${new Date(
																			new Date()
																		).toLocaleDateString(
																			"pt-BR"
																		)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">DM</div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.aceite
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}/${
							res.data.calculanossonumero
						}-${res.data.calculadac2}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center"></div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center" style="font-size:11.5px;">R$</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="top">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                                        ${parseFloat(
																			titulo.valorliqtitulo
																		).toLocaleString(
																			"pt-br",
																			{
																				style: "currency",
																				currency:
																					"BRL",
																			}
																		)}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height="90" colspan="3" rowspan="3" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;font-weight:bold;">
                                                                <span>
                                                                    ${
																		res.data
																			.instrucoes[0]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[1]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[2]
																	}</br>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (-) Desconto/Abatimento</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (+) Mora/Multa</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (=) Valor Cobrado</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="434" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.cliente
																	}<br>
                                                                    ${
																		res.data
																			.endereco
																	}
                                                                    ${
																		res.data
																			.cep
																	}
                                                                    ${
																		res.data
																			.cidade
																	}-${
							res.data.uf
						}
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    CPF/CNPJ ${
																		res.data
																			.cpfcnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="428">
                                                                <span style="font-size:11.5px">
                                                                    ${
																		res.data
																			.empresa
																	} <br>
                                                                    ${
																		res.data
																			.empresaendereco
																	} - ${
							res.data.empresacep
						} - ${res.data.empresacidade} <br>
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.empresacnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <img style="padding-top: 5px;" src="data:image/png;base64,${
											res.data.base64
										}" />
                                    </td>
                                    <td width="315" valign="top">
                                        <div align="right" style="font-size:11.5px;font-weight:bold;">
                                            Autenticação Mecânica / Ficha de Compensação
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p>&nbsp;</p>
                        </body>
                    </html>`;
						html2pdf(htmlContent, {
							margin: 10,
							filename: nome,
							image: { type: "jpeg", quality: 1 },
							html2canvas: { dpi: 300, letterRendering: true, scale: 2 },
							jsPDF: {
								unit: "pt",
								format: "a4",
								orientation: "portrait",
							},
						});
						this.listar(0);
					} else {
						this.dialogErro.title = "Erro";
						if (res.data.erro) {
							this.dialogErro.msg = res.data.erro;
						} else {
							this.dialogErro.msg =
								"Não foi possível emitir o boleto";
						}
						this.dialogErro.icon = "mdi-alert-circle-outline";
						this.dialogErro.iconColor = "red";
						this.dialogErro.status = true;
					}
				})
				.catch((e) => {
					this.carregando = false;
					this.dialogLoading = false;
					this.dialogErro.title = "Erro";
					if (e.response.data.erro) {
						this.dialogErro.msg = e.response.data.erro;
					} else {
						this.dialogErro.msg =
							"Não foi possível emitir o boleto";
					}
					this.dialogErro.icon = "mdi-alert-circle-outline";
					this.dialogErro.iconColor = "red";
					this.dialogErro.status = true;
				});
		},
		reimprimirBoleto(titulo) {
			this.carregando = true;
			this.dialogLoading = true;
			return axios
				.post(`${this.backendUrl}parcelamento/boleto/reimprimir`, {
					...titulo,
				})
				.then((res) => {
					this.carregando = false;
					this.dialogLoading = false;
					if (res.data) {
						let htmlContent;
						let data = new Date();
						let nome = `boleto_${
							data.toISOString().split(".")[0]
						}.pdf`;
						htmlContent = `<!DOCTYPE html>
                    <html>
                        <head>
                            <title>Boleto Online</title>
                            <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
                        </head>

                        <body style="padding:15pt !important;">
                            <table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;margin-top:20px;font-family:Arial !important;">
                                <tr>
                                    <td>
                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td colspan="2" rowspan="2" valign="bottom" style="color:white; height:28px;">
                                                </td>
                                                <td width="45%" valign="bottom">
                                                    <div align="right">
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img src="data:image/gif;base64,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" />
                                                    <img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
                                                </td>
                                                <td valign="bottom" style="font-size:12.5px;font-weight:bold;">
                                                    <div align="right">
                                                        <img width="80px" src="data:image/jpeg;base64,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" />
                                                        <br />
                                                        <span>Recibo do Pagador</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Local de Pagamento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:10.5px">
                                                                ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
                                                                NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS 
                                                                E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Vencimento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
                                                                ${
																	titulo.dtvencimento
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">
                                                                ${
																	res.data
																		.cedente
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%" valign="bottom">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.agencia
																		}/${
							res.data.conta
						}-${res.data.digito}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${new Date(
																			new Date()
																		).toLocaleDateString(
																			"pt-BR"
																		)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">DM</div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.aceite
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}/${
							res.data.calculanossonumero
						}-${res.data.calculadac2}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center"></div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center" style="font-size:11.5px;">R$</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="top">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                                        ${parseFloat(
																			titulo.valorliqtitulo
																		).toLocaleString(
																			"pt-br",
																			{
																				style: "currency",
																				currency:
																					"BRL",
																			}
																		)}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height="90" colspan="3" rowspan="3" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;font-weight:bold;">
                                                                <span>
                                                                    ${
																		res.data
																			.instrucoes[0]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[1]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[2]
																	}</br>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (-) Desconto/Abatimento</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (+) Mora/Multa</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (=) Valor Cobrado</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="434" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.cliente
																	}<br>
                                                                    ${
																		res.data
																			.endereco
																	}
                                                                    ${
																		res.data
																			.cep
																	}
                                                                    ${
																		res.data
																			.cidade
																	}-${
							res.data.uf
						}
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    CNPJ/CPF ${
																		res.data
																			.cpfcnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="428">
                                                                <span style="font-size:11.5px">
                                                                    ${
																		res.data
																			.empresa
																	} <br>
                                                                    ${
																		res.data
																			.empresaendereco
																	} - ${
							res.data.empresacep
						} - ${res.data.empresacidade} <br>
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.empresacnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div align="right" style="font-size:11.5px;font-weight:bold;">
                                            Autenticação Mecânica
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td height="5">
                                        ...................................................................................................................................................
                                    </td>
                                </tr>
                            </table>
                            <table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;font-family:Arial !important;">
                                <tr>
                                    <td colspan="2">
                                        <table width="100%"  border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td colspan="2" rowspan="2" valign="bottom" style="color:white;height:28px;">
                                                </td>
                                                <td width="72%" valign="bottom"><div align="right"></div></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img src="data:image/gif;base64,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" />
                                                    <img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
                                                </td>
                                                <td valign="bottom" style="white-space: nowrap;">
                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                        <p style="white-space: nowrap;">
                                                            ${
																res.data
																	.numeroboleto
															}
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Local de Pagamento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:10.5px">
                                                                ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
                                                                NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS 
                                                                E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px">
                                                                Vencimento
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
                                                                ${
																	titulo.dtvencimento
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" valign="bottom">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;">
                                                                ${
																	res.data
																		.cedente
																}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%" valign="bottom">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.agencia
																		}/${
							res.data.conta
						}-${res.data.digito}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${new Date(
																			new Date()
																		).toLocaleDateString(
																			"pt-BR"
																		)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">DM</div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.aceite
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}/${
							res.data.calculanossonumero
						}-${res.data.calculadac2}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center"></div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <div align="center">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                            <tr>
                                                                <td>
                                                                    <div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div align="center" style="font-size:11.5px;">
                                                                        ${
																			res
																				.data
																				.carteira
																		}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td width="150" height="32" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td>
                                                                <div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div align="center" style="font-size:11.5px;">R$</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="top">
                                                    <div align="right">
                                                        <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="96%">
                                                                    <div align="right" style="font-size:13.5px;font-weight:bold;">
                                                                        ${parseFloat(
																			titulo.valorliqtitulo
																		).toLocaleString(
																			"pt-br",
																			{
																				style: "currency",
																				currency:
																					"BRL",
																			}
																		)}
                                                                    </div>
                                                                </td>
                                                                <td width="4%">&nbsp;</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height="90" colspan="3" rowspan="3" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="6">&nbsp;</td>
                                                            <td width="438" style="font-size:11.5px;font-weight:bold;">
                                                                <span>
                                                                    ${
																		res.data
																			.instrucoes[0]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[1]
																	}</br>
                                                                    ${
																		res.data
																			.instrucoes[2]
																	}</br>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (-) Desconto/Abatimento</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (+) Mora/Multa</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="250" height="28" valign="bottom">
                                                    <table width="100%" border="0" cellpadding="1" cellspacing="0">
                                                        <tr>
                                                            <td colspan="2" style="font-size:11.5px;">
                                                                <div align="left">&nbsp; (=) Valor Cobrado</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="96%">
                                                                <div align="right"></div>
                                                            </td>
                                                            <td width="4%">&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" valign="top">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="1">
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="434" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.cliente
																	}<br>
                                                                    ${
																		res.data
																			.endereco
																	}
                                                                    ${
																		res.data
																			.cep
																	}
                                                                    ${
																		res.data
																			.cidade
																	}-${
							res.data.uf
						}
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    CPF/CNPJ ${
																		res.data
																			.cpfcnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10">&nbsp;</td>
                                                            <td width="428">
                                                                <span style="font-size:11.5px">
                                                                    ${
																		res.data
																			.empresa
																	} <br>
                                                                    ${
																		res.data
																			.empresaendereco
																	} - ${
							res.data.empresacep
						} - ${res.data.empresacidade} <br>
                                                                </span>
                                                            </td>
                                                            <td width="250" style="font-size:11.5px">
                                                                <span>
                                                                    ${
																		res.data
																			.empresacnpj
																	}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <img style="padding-top: 5px;" src="data:image/png;base64,${
											res.data.base64
										}" />
                                    </td>
                                    <td width="315" valign="top">
                                        <div align="right" style="font-size:11.5px;font-weight:bold;">
                                            Autenticação Mecânica / Ficha de Compensação
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p>&nbsp;</p>
                        </body>
                    </html>`;
            html2pdf(htmlContent, {
              margin: 10,
              filename: nome,
              image: { type: "jpeg", quality: 1 },
              html2canvas: { dpi: 250, letterRendering: true, scale: 2 },
              jsPDF: {
                unit: "pt",
                format: "a4",
                orientation: "portrait",
              },
            });
						this.listar(0);
					} else {
						this.dialogErro.title = "Erro";
						if (res.data.erro) {
							this.dialogErro.msg = res.data.erro;
						} else {
							this.dialogErro.msg =
								"Não foi possível emitir o boleto";
						}
						this.dialogErro.icon = "mdi-alert-circle-outline";
						this.dialogErro.iconColor = "red";
						this.dialogErro.status = true;
					}
				})
				.catch((e) => {
					this.carregando = false;
					this.dialogLoading = false;
					this.dialogErro.title = "Erro";
					if (e.response.data.erro) {
						this.dialogErro.msg = e.response.data.erro;
					} else {
						this.dialogErro.msg =
							"Não foi possível emitir o boleto";
					}
					this.dialogErro.icon = "mdi-alert-circle-outline";
					this.dialogErro.iconColor = "red";
					this.dialogErro.status = true;
				});
		},
		async init() {
			this.busca.idfilial = this.usuario.idfilial;
			if (this.$route.params.idcliente) {
				this.busca.idcliente = this.$route.params.idcliente;
				this.busca.titulo = this.$route.params.titulo;
				await this.carregarClientes(`${this.busca.idcliente}`);
				await this.listar();
			}
		},
	},
	watch: {
		search: function (val) {
			this.carregarClientes(val);
		},
		searchMobile: function (val) {
			this.carregarClientes(val);
		},
	},
	created() {
		this.init();
	},
};
</script>